export default (list) => {
  const roles = list.filter(role => window.allowedRoles.map(x => x.role).indexOf(role.name) !== -1)
  return roles
}
